module.exports = __webpack_public_path__ + "img/12.4cc7215e.jpg";